import { render, staticRenderFns } from "./newUsers.vue?vue&type=template&id=7d752fda&scoped=true&"
import script from "./newUsers.vue?vue&type=script&lang=js&"
export * from "./newUsers.vue?vue&type=script&lang=js&"
import style0 from "./newUsers.vue?vue&type=style&index=0&id=7d752fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d752fda",
  null
  
)

export default component.exports